import { useEffect } from 'react';

import { useCashAdjustment } from '../../hooks/cash/useCashAdjustment';
import { useCashSession } from '../../hooks/cash/useCashSession';

import CashSessionHeader from '../CashStatus/CashSessionHeader';
import CashSessionStats from '../CashStatus/CashSessionStats';
import CashSessionFooter from '../CashStatus/CashSessionFooter';
import EmptyCashSessionState from '../CashStatus/EmptyCashSessionState';

const CashAdjustmentSessionCard = () => {
  const { open } = useCashAdjustment();
  const { activeSession, getActiveSession } = useCashSession();

  useEffect(() => {
    if (!activeSession) {
      getActiveSession();
    }
  }, []);

  if (!activeSession) {
    return <EmptyCashSessionState />;
  }

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <CashSessionHeader
        onAction={open}
        actionLabel="Nuevo Ajuste"
        actionColor="#f59e0b"
      />

      <CashSessionStats
        registerName={activeSession.registerName}
        userName={activeSession.openedByName}
        openingTime={activeSession.openedAt}
      />

      <CashSessionFooter currentBalance={activeSession.currentBalance} />
    </div>
  );
};

export default CashAdjustmentSessionCard;
